module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "barHolder"
  }, [_c('div', {
    staticClass: "barFill",
    class: {
      'paused': _vm.pause
    },
    style: ({
      'width': _vm.currentBarWidth
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2eb852"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/notifications/floatingNotifications/timedBar.vue
// module id = 2098
// module chunks = 0